import InPay from "@/views/outsidesettle/inpay/InPay"
export const inpay = {
    path: '/inpay',
    name: 'InPay',
    component: InPay
  }


// WEBPACK FOOTER //
// ./src/router/index/outsidesettle/inpay/index.js